import { Flex, Box } from '@chakra-ui/react';
import { FC } from 'react';
import { CustomStarFilled } from '../../../config/icons';
import { HotelTeaserFragmentFragment } from '../../../generated/types';
import getIconForCategoryKey from '../../../utils/getIconForCategoryKey';
import { HTMLText } from '../../Common/HTMLText';
import ImageTextTeaserBase from '../../Common/ImageTextTeaserBase';

interface NearHotelTeaserProps {
  data: HotelTeaserFragmentFragment;
}

export const NearHotelTeaser: FC<NearHotelTeaserProps> = ({ data }) => {
  const Icon = getIconForCategoryKey('hotel');

  return (
    <ImageTextTeaserBase
      linkText="Check it now"
      url={data.url}
      image={data.teaserImage?.teaserTextSmall?.url}
      my={0}
      mx={0}
      bg={`rgba(0,0,0, .65)`}
      padding={{
        base: 4,
        md: 8,
      }}
      imgProps={{
        htmlHeight: '322px',
        htmlWidth: '500px',
      }}
    >
      <Flex alignItems="center">
        <Box
          alignSelf="flex-start"
          padding={2}
          borderRadius={{
            base: 0,
            md: 'lg',
          }}
          display="inline-flex"
          fontSize={{
            base: 'xl',
            md: '3xl',
          }}
          border="2px solid"
          borderColor="textColor"
          color="#fff"
        >
          <Icon />
        </Box>
        <Box
          ml={4}
          fontSize={{
            base: 'md',
            md: 'lg',
          }}
          fontWeight="bold"
        >
          {data.title}
        </Box>
      </Flex>
      <Flex
        alignItems="center"
        mt={4}
        fontSize={{
          base: 'md',
          md: 'xl',
        }}
        whiteSpace="nowrap"
      >
        ab{' '}
        <Box ml={2} as="span">
          {data.minPrice} €
        </Box>
        {data.averageRating.ratingCount > 0 && (
          <>
            <Box mx={3}>|</Box>

            <Flex alignItems="center">
              <CustomStarFilled marginRight={1} fill="starColor" />{' '}
              {data.averageRating.total.toFixed(1)} (
              {data.averageRating.ratingCount} Bewertungen)
            </Flex>
          </>
        )}
      </Flex>
      <Box marginY={2} width="60px" height="2px" bg="brand.600" />
      {data.detailsForFrontend && (
        <HTMLText
          text={data.detailsForFrontend.body}
          truncate={130}
          display={{
            base: 'none',
            md: 'block',
          }}
        />
      )}
    </ImageTextTeaserBase>
  );
};
